import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import usePrivileges from '../../Auth/usePrivileges';
import ConfigurationContext from '../../Contexts/ConfigurationContext';
import CreateNewLotDialog from '../../Dialogs/CreateNewLotDialog';
import { useUserAssignedBusinessUnits } from '../../Utilities/useUserAssignedBusinessUnits';

function CreateNewLotButton() {

    const { t } = useTranslation();
    const { admin, canReview } = usePrivileges();
    const [showDialog, setShowDialog] = useState(false);
    const { userAssignedBusinessUnits } = useUserAssignedBusinessUnits();
    const { configurationData } = useContext(ConfigurationContext);
    const [siteCanManuallyCreateLot, setSiteCanManuallyCreateLot] = useState(false);
    const userCanManuallyCreateLot = admin || canReview;
    const buttonEnabled = siteCanManuallyCreateLot && userCanManuallyCreateLot;

    useEffect(() => {
        if (configurationData && userAssignedBusinessUnits) {
            const canShow = configurationData.some(config =>
                config.name === "CanManuallyCreateLot" &&
                config.value === "true" &&
                userAssignedBusinessUnits.some(bu => bu.businessUnitId === config.businessUnitId)
            );
            setSiteCanManuallyCreateLot(canShow);
        }
    }, [configurationData, userAssignedBusinessUnits]);

    return (buttonEnabled && 
        <>
            <Button variant="primary"
                onClick={() => setShowDialog(true)}>
                {t('LotList.CreateNewLot')}
                <FontAwesomeIcon icon={faPlus} className="ms-1" />
            </Button>
            {showDialog &&
                <CreateNewLotDialog showDialog={showDialog} closeDialog={() => setShowDialog(false)} />
            }
        </>
    );
}

export default CreateNewLotButton;